module.exports = {"id":"192557","name":"Marvin Plattenhardt","rating":"78","photo":"./data/images/photos/1/192557.png","club":{"name":"Hertha Berlin","logo":"./data/images/clubs/HerthaBerlin.png"},"positions":["DG"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MarvinPlattenhardt0.json
// module id = 2836
// module chunks = 0